import { Heading, HFlow, VFlow } from 'bold-ui'
import { FormSectionAccordion } from 'components/accordion/FormSectionAccordion'
import { DateField } from 'components/form'
import { css } from 'emotion'
import { useServerTime } from 'hooks/useServerTime'
import { toDate } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'
import { PeriodoAusenciaTable } from 'view/cidadao/create/components/PeriodoAusenciaTable'

import { CidadaoAldeadoFormModel } from '../types/model-cidadao'

interface PeriodoAusenciaSaudeIndigenaFormSectionProps {
  meta: MetaPath<CidadaoAldeadoFormModel>
  values: CidadaoAldeadoFormModel
  dataNascimento?: string
}

export const PeriodoAusenciaSaudeIndigenaFormSection = (props: PeriodoAusenciaSaudeIndigenaFormSectionProps) => {
  const { meta, values, dataNascimento } = props
  const { getServerTimeNow } = useServerTime()
  const now = getServerTimeNow()
  const minDate = dataNascimento ? toDate(dataNascimento) : null

  const historico = values?.periodoAusenciaList || []

  return (
    <VFlow>
      <Heading level={2}>Período de ausência</Heading>
      <HFlow justifyContent='space-between'>
        <DateField name={meta.dtAusencia} label='Data da ausência' maxDate={now} minDate={minDate} />
        <DateField name={meta.dtRetorno} label='Data do retorno' maxDate={now} minDate={minDate} />
      </HFlow>

      <FormSectionAccordion
        name={meta.openedAccordionPeriodos}
        title='Histórico de datas'
        uuid='historicodatas'
        textStyle={css`
          font-size: 1rem;
        `}
      >
        <PeriodoAusenciaTable periodoAusenciaList={historico} />
      </FormSectionAccordion>
    </VFlow>
  )
}
